<div class="overlay"></div>
<section class="app-outlet">
  <app-header *ngIf="isLoggedin"></app-header>
  <main class="h-100">
    <div class="h-100 d-flex justify-content-center">
      <div [ngClass]="[isLoggedin? 'div_router_outlet'  : '', ]">
        <router-outlet>
        </router-outlet>
      </div>
    </div>
  </main>
  <app-footer></app-footer>
</section>
<p-toast position="bottom-center" [showTransitionOptions]="'0ms'" [hideTransitionOptions]="'0ms'"></p-toast>
